import { environment } from 'src/environments/environment';

export const BackgroundBaseData: iBackground = {
  header: true,
  tall: false,
  color: '#132847',
  image: false,
  title: environment.production ? 'דובר צה״ל' : 'דובר צה״ל - בטא',
  logo: 'spokesperson'
};

export interface iBackground {
  header?: boolean;
  tall?: boolean;
  color?: '#132847' | string;
  image?: false | string;
  title?: string;
  logo?: 'idf' | 'spokesperson' | false;
}
